import { useContext } from "react";
import Context from "./Context";
import LoggedInHeader from "./components/pages/loggedIn/LoggedInHeader";
import styled from "styled-components";
import WithBackground from "./components/core/boilerplate/WithBackground";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100vw;
`;

const ContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 30px;
  flex: 1;
`;

const MobileMain = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

// if (!loggedInUser) {
//   console.log("currentRoute", currentRoute);
//   return null;
// }

export default function WithLoggedInHeader({ children }) {
  const { loggedInUserId, isMobile, currentRoute } = useContext(Context);

  let isUserPage = currentRoute.indexOf("/u/") !== -1;

  let isContentPage = currentRoute.indexOf("/p/") !== -1;

  if (!loggedInUserId && !isUserPage && !isContentPage) {
    console.log("currentRoute", currentRoute);
    return children;
  }

  if (isMobile) {
    return (
      <ContainerMobile>
        <LoggedInHeader />
        <MobileMain>{children}</MobileMain>
      </ContainerMobile>
    );
  }

  // return null;
  return (
    <Container>
      <LoggedInHeader />
      <Main>{children}</Main>
    </Container>
  );
}
